import React from "react";
import 'aframe'
import GraphVisualization from "./GraphVisualization";

const nodes = [
  { "id": 1, "name": "DNZ-01-Demokrasi", "lat": 37.75464, "log": 29.09111 },
  { "id": 2, "name": "DNZ-02-ZübeydeHanım", "lat": 37.75994, "log": 29.09225 },
  { "id": 3, "name": "DNZ-03-İnciliPınar", "lat": 37.76492, "log": 29.09877 },
  { "id": 4, "name": "DNZ-04-UlusTokat", "lat": 37.75458, "log": 29.09930 },
  { "id": 5, "name": "DNZ-05-UlusBursa", "lat": 37.75317, "log": 29.09519 },
  { "id": 6, "name": "DNZ-06-HavuzluKöşk", "lat": 37.75153, "log": 29.09194 },
  { "id": 7, "name": "DNZ-07-Tiyatro", "lat": 37.75089, "log": 29.08563 },
  { "id": 8, "name": "DNZ-08-İnönüÇamlık", "lat": 37.75808, "log": 29.08291 },
  { "id": 9, "name": "DNZ-09-KıbrısŞehitleriİnönü", "lat": 37.76244, "log": 29.08922 },
  { "id": 10, "name": "DNZ-10-10Nisan", "lat": 37.76791, "log": 29.09499 },
  { "id": 11, "name": "DNZ-11-PelitliBağ", "lat": 37.77189, "log": 29.09496 },
  { "id": 12, "name": "DNZ-12-SuluKöprü", "lat": 37.77094, "log": 29.09174 },
  { "id": 13, "name": "DNZ-13-HacıKaplanlar", "lat": 37.77508, "log": 29.09237 },
  { "id": 14, "name": "DNZ-14-Çınar", "lat": 37.77353, "log": 29.08733 },
  { "id": 15, "name": "DNZ-15-Lise", "lat": 37.76897, "log": 29.08406 },
  { "id": 16, "name": "DNZ-16-KıbrısŞehitleriEmek", "lat": 37.76591, "log": 29.08530 },
  { "id": 17, "name": "DNZ-17-OrduEvi", "lat": 37.76812, "log": 29.08153 },
  { "id": 18, "name": "DNZ-18-Kiremitçi", "lat": 37.76803, "log": 29.07899 },
  { "id": 19, "name": "DNZ-19-Karaman", "lat": 37.76953, "log": 29.07507 },
  { "id": 20, "name": "DNZ-20-AkKonak", "lat": 37.77279, "log": 29.07117 },
  { "id": 21, "name": "DNZ-21-Lozan", "lat": 37.77599, "log": 29.07844 },
  { "id": 22, "name": "DNZ-22-MimarSinan", "lat": 37.77574, "log": 29.08209 },
  { "id": 23, "name": "DNZ-23-SıraKapılar", "lat": 37.77828, "log": 29.07716 },
  { "id": 24, "name": "DNZ-24-EsmaHatun", "lat": 37.78111, "log": 29.07519 },
  { "id": 25, "name": "DNZ-25-DevletHastanesi", "lat": 37.78106, "log": 29.07621 },
  { "id": 26, "name": "DNZ-26-SağlıkMüdürlüğü", "lat": 37.78319, "log": 29.08178 },
  { "id": 27, "name": "DNZ-27-Doktorlar", "lat": 37.78188, "log": 29.08287 },
  { "id": 28, "name": "DNZ-28-İtfaiye", "lat": 37.78178, "log": 29.08785 },
  { "id": 29, "name": "DNZ-29-UluCami", "lat": 37.78246, "log": 29.08541 },
  { "id": 30, "name": "DNZ-30-TuranGüneş", "lat": 37.78288, "log": 29.09029 },
  { "id": 31, "name": "DNZ-31-AtatürkHalk", "lat": 37.77787, "log": 29.09608 },
  { "id": 32, "name": "DNZ-32-Emniyet", "lat": 37.77850, "log": 29.09792 },
  { "id": 33, "name": "DNZ-33-Üçgen", "lat": 37.78654, "log": 29.09800 },
  { "id": 34, "name": "DNZ-34-İstasyon", "lat": 37.78450, "log": 29.09051 },
  { "id": 35, "name": "DNZ-35-Halley", "lat": 37.78307, "log": 29.09051 },
  { "id": 36, "name": "DNZ-36-HacılarCami", "lat": 37.78063, "log": 29.08991 },
  { "id": 37, "name": "DNZ-37-Sümer", "lat": 37.78003, "log": 29.08537 },
  { "id": 38, "name": "DNZ-38-AhiSinan", "lat": 37.77991, "log": 29.08129 },
  { "id": 39, "name": "DNZ-39-EskiZahirePazarı", "lat": 37.77944, "log": 29.08058 },
  { "id": 40, "name": "DNZ-40-DörtÇeşme", "lat": 37.77656, "log": 29.07917 },
  { "id": 41, "name": "DNZ-41-ÖzayGönlüm", "lat": 37.77478, "log": 29.07885 },
  { "id": 42, "name": "DNZ-42-BerkayHalıSaha", "lat": 37.77322, "log": 29.07733 },
  { "id": 43, "name": "DNZ-43-KanalKavşağı", "lat": 37.77229, "log": 29.07612 },
  { "id": 44, "name": "DNZ-44-AskeriYol", "lat": 37.77047, "log": 29.07547 },
  { "id": 45, "name": "DNZ-45-Belkon", "lat": 37.76823, "log": 29.07391 },
  { "id": 46, "name": "DNZ-46-Yenişehir", "lat": 37.76561, "log": 29.07232 },
  { "id": 47, "name": "DNZ-47-MeclisOrmanı", "lat": 37.76539, "log": 29.07091 },
  { "id": 48, "name": "DNZ-48-Şirinköy", "lat": 37.76255, "log": 29.06999 },
  { "id": 49, "name": "DNZ-49-Gülistan", "lat": 37.76013, "log": 29.06829 },
  { "id": 50, "name": "DNZ-50-AdliyeLojmanı", "lat": 37.75834, "log": 29.06659 },
  { "id": 51, "name": "DNZ-51-Adliye", "lat": 37.75670, "log": 29.06478 },
  { "id": 52, "name": "DNZ-52-Aydem", "lat": 37.75489, "log": 29.06295 },
  { "id": 53, "name": "DNZ-53-ServergaziHastanesi", "lat": 37.75306, "log": 29.06120 },
  { "id": 54, "name": "DNZ-54-Fabrikalar", "lat": 37.75147, "log": 29.05988 },
  { "id": 55, "name": "DNZ-55-Bakırlı", "lat": 37.74982, "log": 29.05853 },
  { "id": 56, "name": "DNZ-56-BakırlıKöprü", "lat": 37.74804, "log": 29.05718 },
  { "id": 57, "name": "DNZ-57-Levazım", "lat": 37.74627, "log": 29.05586 },
  { "id": 58, "name": "DNZ-58-Zeybek", "lat": 37.74451, "log": 29.05450 },
  { "id": 59, "name": "DNZ-59-Fatih", "lat": 37.74277, "log": 29.05322 },
  { "id": 60, "name": "DNZ-60-Ulus", "lat": 37.74098, "log": 29.05194 },
  { "id": 61, "name": "DNZ-61-Kasaplar", "lat": 37.73917, "log": 29.05068 },
  { "id": 62, "name": "DNZ-62-Pekdemir", "lat": 37.73740, "log": 29.04942 },
  { "id": 63, "name": "DNZ-63-AnadoluLisesi", "lat": 37.73565, "log": 29.04816 },
  { "id": 64, "name": "DNZ-64-Bim", "lat": 37.73389, "log": 29.04690 },
  { "id": 65, "name": "DNZ-65-KınıklıBelediyesi", "lat": 37.73214, "log": 29.04564 },
  { "id": 66, "name": "DNZ-66-EndüstriMeslek", "lat": 37.73040, "log": 29.04438 },
  { "id": 67, "name": "DNZ-67-Üniversite", "lat": 37.72863, "log": 29.04312 },
  { "id": 68, "name": "DNZ-68-KalpMerkezi", "lat": 37.72687, "log": 29.04185 },
  { "id": 69, "name": "DNZ-69-Emsan", "lat": 37.72512, "log": 29.04059 },
  { "id": 70, "name": "DNZ-70-TicaretBorsası", "lat": 37.72335, "log": 29.03933 },
  { "id": 71, "name": "DNZ-71-YüksekTepe", "lat": 37.72158, "log": 29.03807 },
  { "id": 72, "name": "DNZ-72-EsenTepePazarYeri", "lat": 37.72267, "log": 29.03586 }
]


const edges = [
  [1, 2], [2, 1], [1, 3], [3, 1], [1, 4], [4, 1], [1, 5], [5, 1], [1, 6], [6, 1], [1, 7], [7, 1], [1, 8], [8, 1], [1, 59], [59, 1],
  [2, 3], [3, 2], [2, 9], [9, 2], [3, 4], [4, 3], [3, 10], [10, 3], [3, 59], [59, 3], [4, 5], [5, 4], [4, 59], [59, 4], [4, 60], [60, 4],
  [4, 62], [62, 4], [4, 64], [64, 4], [5, 6], [6, 5], [5, 64], [64, 5], [6, 7], [7, 6], [6, 65], [65, 6], [7, 8], [8, 7], [7, 44], [44, 7],
  [8, 9], [9, 8], [8, 16], [16, 8], [8, 17], [17, 8], [9, 10], [10, 9], [9, 16], [16, 9], [10, 11], [11, 10], [10, 12], [12, 10], [11, 12], [12, 11],
  [11, 13], [13, 11], [11, 31], [31, 11], [12, 13], [13, 12], [12, 14], [14, 12], [12, 16], [16, 12], [13, 14], [14, 13], [13, 28], [28, 13],
  [13, 30], [30, 13], [13, 31], [31, 13], [14, 15], [15, 14], [14, 22], [22, 14], [14, 27], [27, 14], [14, 28], [28, 14], [14, 29], [29, 14],
  [14, 40], [40, 14], [15, 16], [16, 15], [15, 17], [17, 15], [15, 22], [22, 15], [16, 17], [17, 16], [17, 18], [18, 17], [17, 19], [19, 17],
  [17, 21], [21, 17], [17, 22], [22, 17], [18, 19], [19, 18], [18, 43], [43, 18], [19, 21], [21, 19], [19, 22], [22, 19], [19, 43], [43, 19],
  [20, 23], [23, 20], [20, 41], [41, 20], [20, 42], [42, 20], [20, 43], [43, 20], [21, 22], [22, 21], [21, 23], [23, 21], [22, 27], [27, 22],
  [23, 24], [24, 23], [23, 26], [26, 23], [24, 25], [25, 24], [24, 41], [41, 24], [25, 26], [26, 25], [25, 39], [39, 25], [26, 27], [27, 26],
  [26, 40], [40, 26], [28, 29], [29, 28], [28, 30], [30, 28], [29, 35], [35, 29], [30, 31], [31, 30], [30, 33], [33, 30], [30, 34], [34, 30],
  [30, 35], [35, 30], [31, 32], [32, 31], [32, 33], [33, 32], [32, 59], [59, 32], [33, 34], [34, 33], [33, 58], [58, 33], [34, 35], [35, 34],
  [34, 37], [37, 34], [34, 58], [58, 34], [35, 36], [36, 35], [36, 37], [37, 36], [36, 38], [38, 36], [36, 40], [40, 36], [37, 38], [38, 37],
  [37, 55], [55, 37], [37, 57], [57, 37], [38, 39], [39, 38], [38, 51], [51, 38], [38, 55], [55, 38], [38, 57], [57, 38], [39, 40], [40, 39],
  [41, 42], [42, 41], [41, 51], [51, 41], [41, 72], [72, 41], [42, 43], [43, 42], [43, 44], [44, 43], [43, 46], [46, 43], [43, 48], [48, 43],
  [44, 45], [45, 44], [45, 46], [46, 45], [46, 47], [47, 46], [47, 48], [48, 47], [48, 49], [49, 48], [49, 50], [50, 49], [50, 51], [51, 50],
  [51, 52], [52, 51], [51, 72], [72, 51], [52, 53], [53, 52], [54, 55], [55, 54], [54, 72], [72, 54], [55, 56], [56, 55], [55, 57], [57, 55],
  [56, 57], [57, 56], [59, 60], [60, 59], [60, 61], [61, 60], [60, 62], [62, 60], [62, 63], [63, 62], [62, 68], [68, 62], [62, 69], [69, 62],
  [63, 64], [64, 63], [63, 66], [66, 63], [63, 67], [67, 63], [64, 65], [65, 64], [65, 66], [66, 65], [67, 68], [68, 67], [68, 69], [69, 68],
  [68, 70], [70, 68], [68, 71], [71, 68], [70, 71], [71, 70]

]

const App = () => (
  <div>
    <h1>Graph Visualization</h1>
    <GraphVisualization nodes={nodes} edges={edges} />
  </div>
);

export default App;